/**
 * @desc 分页查询
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.systemOrder.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemOrder/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
